<div class="container">
    <div class="row no-gutters">
      <div class="col-12">
        <div class="d-flex popup-head align-items-center">
            <div class="popup-title mr-auto" translate>lblAddCheckListItem</div>
                <div class="float-right">
              <a class="close mr-3" (click)="OnClose()" translate>
                <span class="" aria-hidden="true">&times;</span>
              </a>
                </div>
          </div>
           <form [formGroup]="addCheckListItemForm">
            <div class="scrollbar">
              <div class="card-content">
                <div class="card-body p-0">
                  <div class="row">
                    <div class="col-6 af-form-group" id="dealerList" >
                      <label translate>lblChecklistName</label>
                      {{subCheckListTitle}}
                     <!-- checkList sequence  -->
                    </div>
                    <div class="col-6  af-form-group">
                        <label for="name" translate>lblSequence<strong
                          class="mlt6 required"> * </strong></label>
                        <div class='lbl-info'>
                          {{sequenceValue}}
                        </div>
                      </div>
                    

                    <div class="col-6 af-form-group" >
                        <label translate>lblChecklistType</label>
                        <input  class="form-control mb-2" formControlName="colorcheckListType" [ngModel]="cpf.colorcheckListType.value">
                      </div>
                      <div class="col-6 mt-4 pt-6">
                        <div *ngIf="checkListtypeValue == 2">
                          <em class="far fa-circle fa-lg text-info ml-3"></em>
                          <em class = "far fa-circle fa-lg text-success ml-1"></em>
                         </div>
                         <div *ngIf="checkListtypeValue == 3">
                          <em class="far fa-circle fa-lg text-info ml-3"></em>
                          <em class="far fa-circle fa-lg text-success ml-1"></em>
                          <em class="far fa-circle fa-lg text-danger cursordisable ml-1"></em>
                         </div>
                         <div *ngIf="checkListtypeValue == 4">
                          <em class="far fa-circle fa-lg text-info ml-3"></em>
                          <em class="far fa-circle fa-lg text-success ml-1"></em>
                          <em class="far fa-circle fa-lg text-danger cursordisable ml-1"></em>
                          <em class="far fa-circle fa-lg text-warning ml-1"></em>
                         </div>
                    </div>
                    <div class="col-12"></div>
                   
                    <!-- Add Edit  -->
                  <div class="col-6">
                    <div class="lbl-info">
                              <button class="btn btn-primary mr-sm-2 btn-sm " translate aria-label="Center Align"  (click)="onShow()">
                                <em class="far fa-Add font16 align-top mr-2" translate></em>
                                lblAddCheckListQue </button>
                    </div>
                  </div>
                  <div class="container col-12" *ngIf="hideshow">
                  <div class="multicolor-label col-12 ml-1 mt-4">
                  <div class="popup-title-multicolor pl-2 pl-2 mt-4" *ngIf="hideshow && !isEditMode" translate>lblAddCheckListItem</div>
                  <div class="popup-title-multicolor pl-2 pl-2 mt-4" *ngIf="hideshow && isEditMode" translate>lblEditCheckListItem</div>
                </div>
                </div>
                  <div class="container-fluid pl-3 pr-3 pt-3 pb-3" style="border: 1px solid black;
                    margin-top: 20px;
                    margin-left: 10px;
                    margin-right: 10px;" *ngIf="hideshow">
                     
                    <div class="col-12 mt-3 af-form-group" > 
                        <div class="row">
                          <div class="col-6" *ngFor="let ticket of t.controls; let i = index">
                            <div class="" [formGroup]="ticket" >
                              <div class=" af-form-group">
                                <label for="name"><span translate>lblChecklistItemName</span>&nbsp;<span
                                    translate>lblIn</span>
                                    <span>
                                    {{languageList[i].value}}
                                    </span>
                                  <strong class="mlt6 required"> * </strong> </label>
                                <div class="lbl-info">
                                  <input formControlName="name" class="form-control mb-2" maxlength="100">
                                  <div *ngIf="cpf.service.touched && cpf.service.invalid"
                                    class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle"
                                      aria-hidden="true"></em>
                                      lblCheckListItemRequired
                                  </div>
                                </div>
                              </div>

                              <div class="col-6 af-form-group" style="display: none;">
                                <label for="languageId" translate>Language Id</label>
                                <div class="lbl-info">
                                  <input formControlName="languageId" class="form-control mb-2" [ngModel]="languageList[i].id"
                                    maxlength="30">
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- checkList item sequence -->
                      <div class="col-6  af-form-group" >
                        <label for="name" translate>lblSequence<strong
                          class="mlt6 required"> * </strong></label>
                        <div class='lbl-info'>
                          <input formControlName="sequence" class="form-control mb-2"
                            placeholder="{{ 'lblSequence' | translate }}" required pattern="^[0-9]{1,7}$">
                          <div *ngIf="!isSubmitted && cpf.sequence.invalid && (cpf.sequence.dirty || cpf.sequence.touched)"
                            class="help-block text-danger">
                            <div *ngIf="cpf.sequence.errors.pattern"><span translate>lblProperValue</span>
                            </div>
                            <div *ngIf="cpf.sequence.errors.min" translate>
                              lblMinimumRequiredNumber
                            </div>
                            <div *ngIf="cpf.sequence.errors.max" translate>
                              lblMaximunRequiredNumber
                            </div>
                            <div *ngIf="cpf.sequence.errors.required" translate>
                              lblSequenceRequired
                            </div>
                          </div>
                        </div>
                      </div>
                     <!-- Question & camera -->

                      <div class="col-12 af-form-group mt-2" >
                        <div class="row">
                        
                          <div class='col-auto lbl-info'>
                            <div class="form-check pl-0">
                              
                              <label class="text " for="isQuestionActive" translate>
                                <input type="checkbox" name="isQuestionActive" id="isQuestionActive"
                                formControlName="isQuestionActive" class="">
                                lblQuestionActive
                                <span>?</span>
                              </label>
                            </div>
                          </div>
                          <div class='col-auto lbl-info'>
                            <div class="form-check pl-0">
                              
                              <label class="text " for="makeCameraAvailable"
                                translate>
                                <input type="checkbox" name="makeCameraAvailable" id="makeCameraAvailable"
                                formControlName="camaraAvailable" class="">
                                lblMakeCameraAvailable
                              </label>
                            </div>
                          </div>
                        </div>
                      </div> 

                      <!-- Camera -->
                      <div class="col-12 af-form-group" *ngIf="addCheckListItemForm.value.camaraAvailable">
                        <hr />
                        <h4 class="font-15 text-bold mb-2" translate>lblMakeCameraAvailable</h4>
                        <div class='lbl-info'>
                          <input type="text" class="form-control mb-2" formControlName="photoGraphyDetails"
                            placeholder="{{ 'lblPhotographyGuid' | translate }}" required>
                        </div>
                      </div>
                       
                      <!-- Question Add button  -->
                      <div class='col-12 af-form-group text-right' *ngIf="!isEditMode">
                        <div class="lbl-info">
                            <button class="btn btn-primary mr-sm-2 btn-sm" translate aria-label="Center Align" [disabled]="cpf.service.invalid || cpf.sequence.invalid" (click)="AddCheckListItems()" >
                                <em class="fa fa-plus font16 align-top mr-2" translate></em>
                                lblAdd </button>
                        </div>
                      </div>
                        <!-- Question update button  -->
                      <div class='col-12 af-form-group text-right' *ngIf="isEditMode">
                        <div class="lbl-info">
                            <button class="btn btn-primary mr-sm-2 btn-sm" translate aria-label="Center Align"  [disabled]="cpf.service.invalid || cpf.sequence.invalid" (click)="EditCheckListItems()">
                                <em class="far fa-save font16 align-top mr-2" translate></em>
                                lblSave </button>
                             
                        </div>
                      </div>
                    </div>
                      <!-- Table data list -->
                      <div class="container col-12">
                        <div class="multicolor-label col-12 ml-1 mt-4">
                        <div class="popup-title-multicolor pl-2 pl-2 mt-4"  translate>lblCheckListItem</div>
                      </div>
                      </div>
                      <div class="container-fluid pl-3 pr-3 pt-3 pb-3" style="border: 1px solid black;
                        margin-top: 20px;
                        margin-left: 10px;
                       margin-right: 10px;">
                      <div class ="col-12 af-form-group">

                        <table class="tablest1" id="lockappointment">
                            <thead>
                              <tr>
                                <th  scope="col" style="width: 10%">#</th>
                                <th  scope="col"  translate>lblSequence</th>
                                <th  scope="col" *ngFor="let lan of languageList; let i = index" translate>
                                  <span translate>lblTitle</span>&nbsp;<span translate>lblIn</span>
                                  {{lan.value}}
                                </th>
                                <th  scope="col" translate>
                                    lblQuestionActive
                                </th>
                                <th  scope="col" translate>
                                  lblMakeCameraAvailable
                                </th>
                                <th  translate class="text-center">
                                  lblAction
                                </th>        
                              </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngIf="CheckListItemDetails?.length > 0">
                                  <tr  *ngFor="let checkitem of CheckListItemDetails; let i=index">
                                    <td>
                                      {{i+1}}
                                    </td>
                                     
                                    <td>
                                         {{checkitem.sequence}} 
                                    </td>
                                    <td *ngFor="let lan of checkitem.languageData">
                                      {{lan.titleName}}
                                    </td>
                                    <td>
                                      <em class="fas fa-check fa-lg" [ngClass]="checkitem.isQuestionActive ? 'predefine-checkList' : null" *ngIf="checkitem.isQuestionActive === true"></em> 
                                    </td>
                                    <td>
                                       <em class="fa fa-camera fa-lg text-danger" [ngClass]="checkitem.makeCameraAvailable ? 'predefine-checkList' : null" *ngIf="checkitem.makeCameraAvailable === true"></em>
                                    </td>
                                    <td class="nowrap text-center">
                                        <a class="btn btn-ico" ngbTooltip="{{'lblEdit' | translate}}" tooltipClass="custom-revert" *ngIf="userRoleRightsDetails.canEdit"
                                          (click)="editCheckListMap(checkitem)">
                                          <em class="fas fa-pencil-alt fa-lg"></em>
                                        </a>                
                                        <ng-template #disabledView>
                                          <a class="btn btn-ico disabled" ngbTooltip="{{'lblEdit' | translate}}" tooltipClass="custom-revert">
                                            <em class="fas fa-pencil-alt fa-lg"></em>
                                          </a>
                                        </ng-template>
                                        <span class="ico-div" *ngIf="userRoleRightsDetails.canDelete"></span>
                                        <a class="btn btn-ico" ngbTooltip="{{'lblDelete' | translate}}" tooltipClass="custom-revert"
                                          (click)="deleteCheckList(checkitem.id)">
                                          <em class="far fa-trash-alt fa-lg"></em>
                                        </a>
                                        <ng-template #disabledDeleteView>
                                          <a class="btn btn-ico disabled" ngbTooltip="{{'lblDelete' | translate}}" tooltipClass="custom-revert">
                                          <em class="far fa-trash-alt fa-lg"></em>
                                        </a>
                                        </ng-template>
                                      </td>
                                  </tr>
                                </ng-container>
                                <ng-template #load_else>
                                  <tr>
                                    <td colspan="8" class="no-record" translate>
                                      lblNoRecordsFound
                                    </td>
                                  </tr>
                                </ng-template>
                              </tbody>
                            </table>
                      </div>
                    </div>
    
               
                  <!-- Camera -->
                 
  
                </div>
              </div>
            </div>
          </div>
          <div class="p-3 bg-light pp-footer-top-brdr">
            <div class="row">
              <div class="col-9">
                <em class="far fa-circle fa-lg text-info"><label class="ml-2" translate>lblNotChecked</label> </em>
                <em class="far fa-circle fa-lg text-success ml-2"><label class="ml-2" translate>lblChecked</label></em>
                <em class="far fa-circle fa-lg text-danger cursordisable ml-2"><label class="ml-2" translate>lblTobeFixed</label></em>
                <em class="far fa-circle fa-lg text-warning ml-2"><label class="ml-2" translate>lblNeedToBeFix</label></em>
                </div>
                <div class="col-3" style="padding-left: 170px" >
                <a (click)="OnClose()" type="reset" class="btn btn-secondary btn-lg ml-3" translate><em class="far fa-times-circle font16 align-top mr-2"></em> lblCancel</a>
               
            </div>
            </div>
          </div>
        </form> 

    </div>
  </div>
</div>
